/**
 * Helper that clears an replaces every property of an object with the properties of source objects. If objects are
 * arrays, then it replaces all items with new items.
 *
 * Copied & adapted from angular-resource
 */
export function cleanExtend<O extends object>(
  destinationObject: O,
  ...args: object[]
): O {
  // Clean the destination object
  for (const k in destinationObject) {
    if (destinationObject.hasOwnProperty(k)) {
      delete destinationObject[k]
    }
  }

  // Copied every source properties
  return Object.assign(destinationObject, ...args)
}
